<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{$t('general.composants.commentaireListInput.popupTitle')}}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <div class="columns">
        <b-field :label="$t('general.composants.commentaireListInput.popupLibelle')"
          class="column is-12 mgb-0"
          expanded>
          <b-input
            type="textarea"
            custom-class="popup"
            v-model="commentaire"
            :rows="10">
            </b-input>
        </b-field>
      </div>
      <footer class="pdt-20px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="majComAsync()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationGeneral from '@/services/validation/validation';
import cloneDeep from 'lodash/cloneDeep';

export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    maj: {
      type: Function,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      commentaire: null,
    };
  },
  computed: {
    commentaireValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    async majComAsync() {
      if (!this.id
      || this.commentaire === undefined
      || this.commentaire === this.oldValue) {
        return;
      }
      this.isLoading = true;
      try {
        this.error = false;
        await this.maj(this.id, this.commentaire);
        this.commentaireValue = this.commentaire;
        this.$parent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide);
        }
        this.error = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.commentaire = cloneDeep(this.commentaireValue);
  },
};

</script>
